import React, { useState } from "react";
import styles from "../styles/UlcPremiumCalculator.module.css";
import styles1 from "../styles/UlcPremium.module.css";
import SchemeHolderForm from "../components/SchemeHolderForm";
import IndividualPlotOwnerForm from "../components/IndividualPlotOwnerForm";
import GovtNomineeFlatForm from "../components/GovtNomineeFlatForm";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const UlcPremium = () => {
  const [activeTab, setActiveTab] = useState("schemeHolder");
  const navigate = useNavigate();
  const [converterType, setConverterType] = useState("ULC Premium");

  const handleBack = () => {
    navigate(-1);
  };

  const handleDropdownChange = (e) => {
    const selected = e.target.value;
    setConverterType(selected);
    const pathMap = {
      "Area Convertor": "/area-convertor",
      "Built-up Area Calculator": "/built-up-area-calculator",
      "Development Charges": "/development-charges",
      "Premium for Ancillary FSI": "/ancillary-fsi",
      "⁠Premium for Premium FSI": "/premium-fsi",
      "ULC Premium": "/ulc-premium",
    };
    if (pathMap[selected]) navigate(pathMap[selected]);
  };

  const renderForm = () => {
    switch (activeTab) {
      case "schemeHolder":
        return <SchemeHolderForm />;
      case "individualPlot":
        return <IndividualPlotOwnerForm />;
      case "govtNominee":
        return <GovtNomineeFlatForm />;
      default:
        return null;
    }
  };

  return (
    <div className={styles1.UlcPremium_container}>
      <div className={styles1.UlcPremium_header}>
        <button className={styles1.UlcPremium_backButton} onClick={handleBack}>
          <FaArrowLeft />
        </button>
        <h2 className={styles1.UlcPremium_title}>Conversion Calculator</h2>
      </div>

      <div className={styles1.UlcPremium_dropdownContainer}>
        <select
          value={converterType}
          onChange={handleDropdownChange}
          className={styles1.UlcPremium_mainDropdown}
        >
          <option>Area Convertor</option>
          <option>Built-up Area Calculator</option>
          <option>Development Charges</option>
          <option>Premium for Ancillary FSI</option>
          <option>⁠Premium for Premium FSI</option>
          <option>ULC Premium</option>
        </select>
      </div>

      <div className={styles.calculatorULC_subHeader}>
        Excess Exempted Lands Premium Calculator
      </div>

      <div className={styles.calculatorULC_tabs}>
        <button
          className={`${styles.calculatorULC_tabButton} ${
            activeTab === "schemeHolder" ? styles.calculatorULC_activeTab : ""
          }`}
          onClick={() => setActiveTab("schemeHolder")}
        >
          Scheme Holder
        </button>
        <button
          className={`${styles.calculatorULC_tabButton} ${
            activeTab === "individualPlot" ? styles.calculatorULC_activeTab : ""
          }`}
          onClick={() => setActiveTab("individualPlot")}
        >
          Individual Plot Owner
        </button>
        <button
          className={`${styles.calculatorULC_tabButton} ${
            activeTab === "govtNominee" ? styles.calculatorULC_activeTab : ""
          }`}
          onClick={() => setActiveTab("govtNominee")}
        >
          Government Nominee Flat Re-sale
        </button>
      </div>

      <div className={styles.calculatorULC_formSection}>{renderForm()}</div>
    </div>
  );
};

export default UlcPremium;
